import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form-mui";
import { useTranslation } from "react-i18next";

import { GqlPermissions } from "~/__generated__";
import GaiaSliderElement from "~/modules/app/components/GaiaSliderElement";
import SliderTextInput from "~/modules/app/components/GaiaSliderElement/SliderTextInput";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";

import { ProtocolVisitFormInput } from "../ProtocolVisitsEditor/VisitEditForm";

type Props = {
    formContext: UseFormReturn<ProtocolVisitFormInput>;
};

export default function ProtocolVisitsPricingEditor({ formContext }: Props) {
    const { t } = useTranslation("protocol");
    const { control } = formContext;
    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);
    return (
        <Stack direction="column">
            <GaiaSliderElement
                disabled={!isAdmin}
                control={control}
                label={t("protocolVisitsPricingEditor.labelPricePerHour")}
                name="pricePerHourInEuros"
                step={0.5}
                min={45}
                max={150}
                valueLabelFormat={value => `€${value}`}
                inputElement={({ min, max, step }) => (
                    <SliderTextInput
                        control={control}
                        name="pricePerHourInEuros"
                        disabled={!isAdmin}
                        suffix="€"
                        min={min}
                        max={max}
                        step={step}
                    />
                )}
            />
            <Controller
                name="calculateTravelCost"
                control={control}
                render={({ field }) => (
                    <FormControlLabel
                        disabled={!isAdmin}
                        control={<Checkbox checked={!!field.value} onChange={e => field.onChange(e.target.checked)} />}
                        label={t("protocolVisitsPricingEditor.labelcalculateTravelCosts")}
                    />
                )}
            />
        </Stack>
    );
}
